// extracted by mini-css-extract-plugin
export default {"key-value-filter__label":"key-value-filter__label-hkhug"};